export enum USER_ACTIONS {
    SET_BLOCKED = 'SET_BLOCKED',
    REMEMBERED = 'REMEMBERED',
    MFA_REGISTERED = 'MFA_REGISTERED',
    MFA_UNREGISTERED = 'MFA_UNREGISTERED',
    SET_TOKEN = 'SET_TOKEN',
    MFA_TOKEN_VALID = 'MFA_TOKEN_VALID',
    LOGOUT = 'LOGOUT',
    SET_DEALERS = 'SET_DEALERS',
    SET_DEFAULT_DEALER = 'SET_DEFAULT_DEALER',
    SET_DEALER_DATA = 'SET_DEALER_DATA',
    SET_DEFAULT_DISTRICT = 'SET_DEFAULT_DISTRICT',
}

export enum PAYMENTS {
    PAYMENT_INFO = 'PaymentInfo',
    PAYMENT_DATA = 'PaymentData',
    PAYMENT_INFO_DELETE = 'DeletePaymentInfo',
}

export enum CREDIT {
    CREDIT_DETAIL = 'CreditDetail',
    CREDIT_DETAIL_DELETE = 'DeleteCreditDetail',
}

export enum MODAL_CONTROL_ACTIONS {
    SET_ACTIVE = 'MODAL_SET_ACTIVE',
    SET_INACTIVE = 'MODAL_SET_INACTIVE',
    SET_SHOW = 'MODAL_SET_SHOW',
}

export enum CREDIT_FORM_TOUCH_ACTIONS {
    MARK_CREDIT_FORM_TOUCHED = 'MARK_CREDIT_FORM_TOUCHED',
    MARK_CREDIT_FORM_UNTOUCHED = 'MARK_CREDIT_FORM_UNTOUCHED',
}

export enum DEALER_ADMIN {
    DEALER_ADMIN_USER_SEARCH = 'DEALER_ADMIN_USER_SEARCH',
    DEALER_ADMIN_USER_ADD_SELECTED = 'DEALER_ADMIN_USER_ADD_SELECTED',
    DEALER_ADMIN_USER_DELETE = 'DEALER_ADMIN_USER_DELETE',
    DEALER_ADMIN_USER_MIGRATION = 'DEALER_ADMIN_USER_MIGRATION',
    SET_DEALER_GROUP_DATA = 'SET_DEALER_GROUP_DATA',
}
